exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination-item[data-v-3fa40754]{width:36px;height:36px;padding:0}.pagination-item.is-active[data-v-3fa40754]{background-color:var(--secondary);color:#fff}", ""]);

// exports
